import React from 'react';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import { withNamespaces } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { BoxWithTitle } from '../../../../components/common';
import { updateAttachedFiles, updateCompany } from '../../../../redux/actions/ReferralActions';
import { getCompany } from '../../../../redux/reducers/ReferralReducer';
import StepsFooter from '../steps/StepsFooter';
import { CommercialNameInput } from '../components/inputs/CommercialNameInput';
import { CompanyRFCInput } from '../components/inputs/CompanyRFCInput';
import { FullAddressInput } from '../components/inputs/FullAddressInput';
import { CompanyLegalNameInput } from '../components/inputs/CompanyLegalNameInput';
import { CountryInput } from '../components/inputs/CountryInput';
import { ClabeInput } from '../components/inputs/ClabeInput';
import { WebInput } from '../components/inputs/WebInput';
import { orderEatCompanyStepValidation } from './validations';
import { DropFileInput } from '../components/DropFileInput';

const OrderEatCompanyStep = ({ t, hasPrevious, handlePrevStep, handleNextStep, lastStep, activeStep, updateCompany, updateAttachedFiles, company }) => {
  const handleSubmit = (values) => {
    updateAttachedFiles({
      socialContract: values.socialContract,
      organizationChart: values.organizationChart,
    });
    delete values.socialContract;
    delete values.organizationChart;
    updateCompany(values);
    handleNextStep();
  };

  const getValidationSchema = () => {
    const { commercialName, legalName, rfc, clabe, fullAddress, country, web, socialContract, organizationChart } = orderEatCompanyStepValidation(t);

    return Yup.object().shape({
      commercialName,
      legalName,
      rfc,
      clabe,
      fullAddress,
      country,
      web,
      socialContract,
      organizationChart,
    });
  };

  const footerProps = {
    hasPrevious,
    handlePrevStep,
    lastStep,
    activeStep,
    t,
  };

  const organizationChartInstructions = [
    {
      id: 1,
      text: 'Firmado y fechado por el representante legal.',
    },
    {
      id: 2,
      text: 'Identificando toda la cadena accionaria hasta alcanzar los beneficiarios finales con más del 10%',
    },
    {
      id: 3,
      text: 'Debe incluir nombre completo de personas fisicas y juridicas, e incluir el porcentaje accionario',
    },
  ];

  return (
    <Formik
      onSubmit={(values, actions) => {
        handleSubmit(values, actions);
      }}
      values
      enableReinitialize
      validationSchema={getValidationSchema}
      validateOnChange
      initialValues={company}
    >
      {({ errors, touched, values, isSubmitting }) => (
        <Form>
          <BoxWithTitle title={t('labelCompanyInformation')}>
            <div className="row">
              <div className="col-lg-6">
                <CommercialNameInput t={t} errors={errors} touched={touched} />
                <CompanyRFCInput t={t} errors={errors} touched={touched} />
                <FullAddressInput t={t} errors={errors} touched={touched} />
                <WebInput t={t} errors={errors} touched={touched} />
                <DropFileInput name="organizationChart" label={t('labelOrganizationChart')} values={values} instructions={organizationChartInstructions} />
              </div>
              <div className="col-lg-6">
                <CompanyLegalNameInput t={t} errors={errors} touched={touched} />
                <CountryInput t={t} errors={errors} touched={touched} />
                <ClabeInput t={t} errors={errors} touched={touched} />
                <DropFileInput name="socialContract" label={t('labelSocialContract')} values={values} />
              </div>
            </div>
          </BoxWithTitle>
          <StepsFooter {...footerProps} isSubmitting={isSubmitting} />
        </Form>
      )}
    </Formik>
  );
};

const mapStateToProps = (state) => {
  return {
    company: getCompany(state),
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updateCompany,
      updateAttachedFiles,
    },
    dispatch
  );

export default compose(withNamespaces(), connect(mapStateToProps, mapDispatchToProps))(OrderEatCompanyStep);
